import {
  IsNotEmpty,
  IsNumberString,
  IsOptional,
  IsString,
  ValidateNested,
  ValidateIf,
  Validate,
} from 'class-validator';
import { Type } from 'class-transformer';

import BaseIvrNode from './baseIvrNode';
import PhoneNumberE164OrGoTemplateIsValid from 'src/models/validators/PhoneNumberE164OrGoTemplateValidator';

export default class ForwardNode extends BaseIvrNode {
  @ValidateNested()
  @Type(() => PhoneNumberWithExtension)
  number: PhoneNumberWithExtension;
}

class PhoneNumberWithExtension {
  @IsString()
  @IsNotEmpty({ message: 'Phone should not be empty' })
  @Validate(PhoneNumberE164OrGoTemplateIsValid)
  phoneNumber: string;

  @IsNumberString()
  @ValidateIf(o => o.extension !== '')
  @IsOptional()
  extension?: string;
}
